import { Link } from "react-router-dom";

export default function Breadcrumbs({ trail }) {
  return (
    <nav className="gp-crumbs" aria-label="Breadcrumb" data-testid="breadcrumbs">
      {trail.map((step, i) => {
        const isLast = i === trail.length - 1;
        return (
          <span key={i}>
            {i > 0 && <span className="gp-crumbs__sep" aria-hidden="true">/</span>}
            {isLast ? (
              <span className="gp-crumbs__current">{step.label}</span>
            ) : (
              <Link to={step.to} data-testid={`crumb-${slug(step.label)}`}>
                {step.label}
              </Link>
            )}{" "}
          </span>
        );
      })}
    </nav>
  );
}

function slug(s) {
  return s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
}
